import { InputFollowupFileToUpload } from './input-followup-file-to-upload';

export class InputAdministrativeQueryFollowup {
    administrative_query_id: number;
    followup_text?: string;
    input_filename_to_upload?: InputFollowupFileToUpload
}